import { UserRole } from '@interfaces/users.interface';

export const mapUserRole = (role: UserRole): string => {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'customer':
      return 'Cliente';
  }
};

export const getMarketCategoryColor = (category: string) => {
  switch (category) {
    case 'Alimentare':
      return '#E18B4E';
    case 'Cosmetico':
      return '#C9375A';
    case 'Nutraceutico':
      return '#129590';
    case 'Farmaceutico':
    case 'Pharma':
      return '#4A7BB4';
    case 'Ricerca':
    case 'Ricerca Scientifica':
      return '#9EC390';
    default:
      return '#868E96';
  }
};
